// extracted by mini-css-extract-plugin
export default {"root":"Modal_root__qGITi","footer":"Modal_footer__gneRk"};